import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from "@angular/router"
import { FolderService } from '../folder.service'
import { Subject, Observable } from 'rxjs'

@Component({
	selector: 'app-folder-version',
	templateUrl: './folder-version.component.html',
	styleUrls: ['./folder-version.component.scss']
})
export class FolderVersionComponent implements OnInit {
	subscription: Subject<any>
	file_id_sub: any
	fileId: string

	versions: Array<any> = []
	head = [
		{key: 'image', display: 'Preview', type: 'thumbnail', thumbnail: 'contain', sort: false, link: 'path'},
		{key: 'username', display: 'Uploaded by', link: 'userpage'},
		{key: 'updated', display: 'Date', type: 'moment', link: 'path'},
		{key: 'type', link: 'path'},
		{key: 'size', type: 'filesize', link: 'path'},
	]

	constructor(
		public folder: FolderService,
		public route: ActivatedRoute,
	) { }

	ngOnInit() {
		if (this.folder.current)
			this.subscribe()
		else
			this.folder.waitForUserInfos(() => this.subscribe())
	}

	subscribe() {
		this.update()
		this.subscription = this.folder.current.subject.asObservable().subscribe(() => this.update())

		this.file_id_sub = this.route.params.subscribe(params => {
			if (params['fileId']) {
				this.fileId = params['fileId']
				this.update()
			}
		})
	}

	update() {
		if (!this.folder.current || !this.fileId) return

		this.versions = Object.values(this.folder.current.versions[this.fileId])
		this.versions = this.versions.map(v => {
			v.username = v.uploaded_by.username || v.uploaded_by.name
			v.userpage = '/user/view/' + v.username
			v.image = v.type.indexOf('image/') > -1 ? v.path : v.fallback
			return v
		})

		console.log(this.versions)

	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-version/folder-version.component.ts